function Footer() {
  return (
    <footer className="footer">
      &copy; {new Date().getFullYear()} Карпов Юрий
    </footer>
  );
}

export default Footer;
